import React from 'react';
import { TOI_LIVE_DOMAIN } from 'constants';
import s from './BiharBoardResult.scss';

const BoardResultDisplay = props => {
  const {
    resultData,
    data,
    resetForm,
    seoData,
    fireClickGa,
    classText,
    columnMapping,
    stateName,
  } = props;

  if (!resultData) {
    return null;
  }

  const { pdfTitle, msid } = data;
  const {
    result_view_type,
    roll_code,
    roll_number,
    app_number,
    district,
    school_code,
    centre_code,
    reg_pvt,
    examinee_name,
    father_name,
    mother_name,
    // school_name,
    group,
    result,
    remark,
    status,
    total_marks,
    obt_marks,
    percentage,
    overallPercentile,
    overallGrade,
    division,
    subjects,
    dob,
  } = resultData;

  let columnKeys = [];
  if (columnMapping && Array.isArray(columnMapping.t_h)) {
    columnKeys = columnMapping.t_h;
  }

  let hightlightedColumn = '';
  if (columnMapping && columnMapping.h_c) {
    hightlightedColumn = columnMapping.h_c;
  }

  if (
    !(
      result_view_type &&
      (result_view_type === 'grade' || result_view_type === 'marksheet')
    )
  ) {
    return null;
  }

  const shareResult = () => {
    if (navigator && navigator.share) {
      navigator
        .share({
          title: seoData ? seoData.title : 'Timesofindia',
          text: `#${stateName}BoardResults #${classText}Results #TOI\n\nI checked my result on TOI${
            examinee_name ? `\nName - ${examinee_name}` : ''
          }${roll_number ? `\nRoll Number - ${roll_number}` : ''}${
            dob ? `\nDate of Birth - ${dob}` : ''
          }${app_number ? `\nApplication Number - ${app_number}` : ''}${
            result ? `\nResult - ${result}` : ''
          }${remark ? `\nRemark - ${remark}` : ''}${
            division ? `\nDivision - ${division}` : ''
          }${
            obt_marks
              ? `\nGrand Total - ${`${obt_marks}${
                  total_marks ? `/${total_marks}` : ''
                }`}`
              : ''
          }${overallGrade ? `\nOverall Grade - ${overallGrade}` : ''}${
            overallPercentile
              ? `\nOverall Percentile - ${overallPercentile}`
              : ''
          }${
            percentage ? `\nPercentage - ${percentage}%` : ''
          }\n\nCheck out detailed results on Times of India website!\n🔗${
            seoData && seoData.canonical
              ? seoData.canonical
              : `${TOI_LIVE_DOMAIN}/${props.location}`
          }\n\nDownload the TOI app for more updates and educational content!\n📱📚 https://timesofindia.onelink.me/mjFd/4haofaqr`,
        })
        .catch(error => console.log('Error sharing:', error));
    } else {
      console.log('Web Share API is not supported in your browser.');
    }
    if (fireClickGa && typeof fireClickGa === 'function') {
      fireClickGa('share_result');
    }
  };

  const downloadPdf = () => {
    if (typeof window === 'object' && window.jspdf && window.html2canvas) {
      const { jsPDF } = window.jspdf;
      const originalElement = document.getElementById('pdf-image-download');
      if (originalElement && jsPDF) {
        window
          .html2canvas(originalElement)
          .then(canvas => {
            const imgData = canvas.toDataURL('image/jpeg', 0.75);
            // eslint-disable-next-line new-cap
            const pdf = new jsPDF();

            pdf.addImage(imgData, 'PNG', 0, 0, 210, 297); // A4 size in mm
            pdf.setTextColor('#0000FF');
            pdf.setFontSize(11);

            const canvasWidth = canvas.width;
            const canvasHeight = canvas.height;
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = canvasHeight * pdfWidth / canvasWidth;

            pdf.textWithLink('Click here', 78, pdfHeight - 20, {
              url:
                seoData && seoData.canonical
                  ? seoData.canonical
                  : `${TOI_LIVE_DOMAIN}${props.location}`,
            });
            pdf.setTextColor('#595959');
            pdf.text('to check your result', 97, pdfHeight - 20);
            pdf.save(
              `${
                typeof pdfTitle === 'string'
                  ? pdfTitle.replaceAll(' ', '_')
                  : 'Board_Results_2024'
              }${roll_number ? `_${roll_number}` : ''}.pdf`,
            );
          })
          .catch(err => {
            console.log(err);
          });
      }
    }
    if (fireClickGa && typeof fireClickGa === 'function') {
      fireClickGa('download_result');
    }
  };

  const getResultData = () => {
    switch (msid) {
      case 109005635:
        return (
          <div className={s.division}>
            <div className={s.head}>Result:</div>
            <div className={s.numbers}>{result}</div>
          </div>
        );
      case 109005657:
        return (
          <>
            <div className={s.division}>
              <div className={s.head}>Result:</div>
              <div className={s.numbers}>{result}</div>
            </div>
            <div className={s.marks}>
              {division && (
                <div className={s.head}>
                  Division: <span>{division}</span>
                </div>
              )}
              {percentage && (
                <div className={s.head}>
                  Percentage: <span>{percentage}</span>
                </div>
              )}
              {obt_marks && (
                <div className={s.head}>
                  Grand Total:{' '}
                  <span>{`${obt_marks}${
                    total_marks ? `/${total_marks}` : ''
                  }`}</span>
                </div>
              )}
            </div>
          </>
        );
      case 109374567:
      case 109374548:
        return (
          <>
            <div className={s.division}>
              <div className={s.head}>Result:</div>
              <div className={s.numbers}>{result || '-'}</div>
            </div>
            {obt_marks && (
              <div className={s.marks}>
                <div className={s.head}>
                  Grand Total (Theory + Practical):{' '}
                  <span>{`${obt_marks}${
                    total_marks ? `/${total_marks}` : ''
                  }`}</span>
                </div>
              </div>
            )}
          </>
        );
      case 109398428:
        return (
          <>
            <div className={s.division}>
              <div className={s.head}>Result:</div>
              <div className={s.numbers}>{status || result || '-'}</div>
            </div>
            {(obt_marks || overallGrade || overallPercentile) && (
              <div className={s.marks}>
                <div className={s.head}>
                  Grand Total:{' '}
                  <span>{`${obt_marks}${
                    total_marks ? `/${total_marks}` : ''
                  }`}</span>
                </div>
                {overallGrade && (
                  <div className={s.head}>
                    Overall Grade: <span>{`${overallGrade}`}</span>
                  </div>
                )}
                {overallPercentile && (
                  <div className={s.head}>
                    Overall Percentile: <span>{`${overallPercentile}`}</span>
                  </div>
                )}
              </div>
            )}
          </>
        );
      case 109398401:
        return (
          <>
            <div className={s.division}>
              <div className={s.head}>Result:</div>
              <div className={s.numbers}>{status || result || '-'}</div>
            </div>
            {(obt_marks || overallGrade || overallPercentile) && (
              <div className={s.marks}>
                <div className={s.head}>
                  Grand Total:{' '}
                  <span>{`${obt_marks}${
                    total_marks ? `/${total_marks}` : ''
                  }`}</span>
                </div>
                {overallGrade && (
                  <div className={s.head}>
                    Overall Grade: <span>{`${overallGrade}`}</span>
                  </div>
                )}
                {overallPercentile && (
                  <div className={s.head}>
                    Overall Percentile: <span>{`${overallPercentile}`}</span>
                  </div>
                )}
              </div>
            )}
          </>
        );

      case 109063180:
      case 109063206:
        return (
          <>
            <div className={s.division}>
              <div className={s.head}>Result:</div>
              <div className={s.numbers}>{result}</div>
            </div>
            <div className={s.marks}>
              {obt_marks && (
                <div className={s.head}>
                  Total Marks Obtained:{' '}
                  <span>{`${obt_marks}${
                    total_marks ? `/${total_marks}` : ''
                  }`}</span>
                </div>
              )}
              {percentage && (
                <div className={s.head}>
                  Percentage: <span>{`${percentage}%`}</span>
                </div>
              )}
            </div>
          </>
        );
      default:
        return (
          <div className={s.division}>
            <div className={s.head}>Result:</div>
            <div className={s.numbers}>{result}</div>
          </div>
        );
    }
  };

  const getUserDetails = () => {
    switch (msid) {
      case 109005635:
      case 109005657:
        return (
          <div className={s.details}>
            {examinee_name && (
              <div className={s.grp}>
                <div className={s.head}>Examinee Name:</div>
                <div className={s.numbers}>{examinee_name}</div>
              </div>
            )}
            {roll_number && (
              <div className={s.grp}>
                <div className={s.head}>Roll No.:</div>
                <div className={s.numbers}>{roll_number}</div>
              </div>
            )}
            {father_name && (
              <div className={s.grp}>
                <div className={s.head}>Father’s Name:</div>
                <div className={s.numbers}>{father_name}</div>
              </div>
            )}
            {mother_name && (
              <div className={s.grp}>
                <div className={s.head}>Mother’s Name:</div>
                <div className={s.numbers}>{mother_name}</div>
              </div>
            )}
          </div>
        );
      case 109374567:
      case 109374548:
        // Add MP Code here
        return (
          <>
            <div className={s.details}>
              <div className={s.grp}>
                <div className={s.head}>Examinee Name:</div>
                <div className={s.numbers}>{examinee_name || '-'}</div>
              </div>
              <div className={s.grp}>
                <div className={s.head}>Roll No:</div>
                <div className={s.numbers}>{roll_number || '-'}</div>
              </div>
              <div className={s.grp}>
                <div className={s.head}>Father&#39;s Name:</div>
                <div className={s.numbers}>{father_name || '-'}</div>
              </div>
              <div className={s.grp}>
                <div className={s.head}>Mother&#39;s Name:</div>
                <div className={s.numbers}>{mother_name || '-'}</div>
              </div>
            </div>
            <div className={s.details}>
              <div className={s.grp}>
                <div className={s.head}>Application No:</div>
                <div className={s.numbers}>{app_number || '-'}</div>
              </div>

              <div className={s.grp}>
                <div className={s.head}>Centre Code:</div>
                <div className={s.numbers}>{centre_code || '-'}</div>
              </div>
              <div className={s.grp}>
                <div className={s.head}>School Code:</div>
                <div className={s.numbers}>{school_code || '-'}</div>
              </div>
              <div className={s.grp}>
                <div className={s.head}>Regular/Private:</div>
                <div className={s.numbers}>{reg_pvt || '-'}</div>
              </div>
            </div>
          </>
        );
      case 109398428:
        return (
          <div className={s.details}>
            <div className={s.grp}>
              <div className={s.head}>Examinee Name:</div>
              <div className={s.numbers}>{examinee_name || '-'}</div>
            </div>
            <div className={s.grp}>
              <div className={s.head}>Roll No:</div>
              <div className={s.numbers}>{roll_number || '-'}</div>
            </div>
          </div>
        );
      case 109398401:
        return (
          <div className={s.details}>
            <div className={s.grp}>
              <div className={s.head}>Examinee Name:</div>
              <div className={s.numbers}>{examinee_name || '-'}</div>
            </div>
            <div className={s.grp}>
              <div className={s.head}>Roll No:</div>
              <div className={s.numbers}>{roll_number || '-'}</div>
            </div>
            <div className={s.grp}>
              <div className={s.head}>Date of Birth:</div>
              <div className={s.numbers}>{dob || '-'}</div>
            </div>
          </div>
        );
      case 109063180:
      case 109063206:
        return (
          <>
            <div className={s.details}>
              {examinee_name && (
                <div className={s.grp}>
                  <div className={s.head}>Examinee Name:</div>
                  <div className={s.numbers}>{examinee_name}</div>
                </div>
              )}
              {group && (
                <div className={s.grp}>
                  <div className={s.head}>Group:</div>
                  <div className={s.numbers}>{group}</div>
                </div>
              )}
              {father_name && (
                <div className={s.grp}>
                  <div className={s.head}>Father’s Name:</div>
                  <div className={s.numbers}>{father_name}</div>
                </div>
              )}
              {mother_name && (
                <div className={s.grp}>
                  <div className={s.head}>Mother’s Name:</div>
                  <div className={s.numbers}>{mother_name}</div>
                </div>
              )}
            </div>
            <div className={s.details}>
              {roll_number && (
                <div className={s.grp}>
                  <div className={s.head}>Roll No.:</div>
                  <div className={s.numbers}>{roll_number}</div>
                </div>
              )}
            </div>
          </>
        );
      default:
        return (
          <div className={s.details}>
            {examinee_name && (
              <div className={s.grp}>
                <div className={s.head}>Examinee Name:</div>
                <div className={s.numbers}>{examinee_name}</div>
              </div>
            )}
            {roll_number && (
              <div className={s.grp}>
                <div className={s.head}>Roll No.:</div>
                <div className={s.numbers}>{roll_number}</div>
              </div>
            )}
            {group && (
              <div className={s.grp}>
                <div className={s.head}>Group:</div>
                <div className={s.numbers}>{group}</div>
              </div>
            )}
            {father_name && (
              <div className={s.grp}>
                <div className={s.head}>Father’s Name:</div>
                <div className={s.numbers}>{father_name}</div>
              </div>
            )}
            {mother_name && (
              <div className={s.grp}>
                <div className={s.head}>Mother’s Name:</div>
                <div className={s.numbers}>{mother_name}</div>
              </div>
            )}
          </div>
        );
    }
  };

  const getDiscalimer = () => {
    switch (msid) {
      case 109005635:
      case 109005657:
        return (
          <div className={s.disclaimer}>
            <span>Disclaimer:</span> The results published on TOI are for
            immediate information to the examinees. These results cannot be
            treated as original marksheet. Original marksheet will be issued
            separately by the Uttar Pradesh State Board. Examinees are advised
            to refer to the official marksheet issued by the Board for
            verification purposes.
          </div>
        );
      case 109374567:
      case 109374548:
        return (
          <div className={s.disclaimer}>
            <span>Disclaimer:</span> The results published on TOI are for
            immediate information to the examinees. These results cannot be
            treated as original marksheet. Original marksheet will be issued
            separately by the Madhya Pradesh Board of Secondary Education
            &#40;MPBSE&#41;. Examinees are advised to refer to the official
            marksheet issued by the Board for verification purposes.
          </div>
        );
      case 109398428:
        return (
          <div className={s.disclaimer}>
            <span>Disclaimer:</span> The results published on TOI are for
            immediate information to the examinees. These results cannot be
            treated as original marksheet. Original marksheet will be issued
            separately by the West Bengal Council of Higher Secondary Education
            &#40;WBCHSE&#41;. Examinees are advised to refer to the official
            marksheet issued by the Board for verification purposes.
          </div>
        );
      case 109398401:
          return (
            <div className={s.disclaimer}>
              <span>Disclaimer:</span> The results published on TOI are for
              immediate information to the examinees. These results cannot be
              treated as original marksheet. Original marksheet will be issued
              separately by the West Bengal Board of Secondary Education
              &#40;WBBSE&#41;. Examinees are advised to refer to the official
              marksheet issued by the Board for verification purposes.
            </div>
        );
      case 109063180:
      case 109063206:
        return (
          <div className={s.disclaimer}>
            <span>Disclaimer:</span> The results published on TOI are for
            immediate information to the examinees. These results cannot be
            treated as original marksheet. Original marksheet will be issued
            separately by the Rajasthan Board of Secondary Education
            &#40;RBSE&#41;. Examinees are advised to refer to the official
            marksheet issued by the Board for verification purposes.
          </div>
        );
      default:
        return null;
    }
  };

  const resultHTML =
    result_view_type === 'marksheet' ? (
      <div className={`${s.result_show} ${s.rajasthan_board}`}>
        <div className={`${s.result_show_full}`}>{getUserDetails()}</div>
        {(result !== 'CONTACT SCHOOL' && result !== 'FULL ABSENT')&&
          Array.isArray(subjects) &&
          subjects.length > 0 && (
            <div className={s.subject_numbers}>
              <ul>
                <li className={s.head}>
                  {columnKeys.map(column => (
                    <span
                      className={`${
                        column && column === 'name' ? s.subjects : s.w_85
                      }`}
                    >
                      {column && column === 'name' ? 'Subjects' : column}
                    </span>
                  ))}
                </li>
                {Array.isArray(subjects) &&
                  subjects.map(subject => {
                    const subNameOpt = subject?.marks !== null;
                    return (
                      <>
                        {subNameOpt && (
                          <li>
                            {columnKeys.map(column => (
                              <span
                                className={`${
                                  column && column === 'name'
                                    ? s.subjects
                                    : s.w_85
                                } ${
                                  column === hightlightedColumn ? s.total : ''
                                }`}
                              >
                                {subject[column] || ''}
                              </span>
                            ))}
                          </li>
                        )}
                      </>
                    );
                  })}
              </ul>
            </div>
          )}
        {stateName &&
        stateName === 'MP' &&
        classText &&
        classText === '10th' ? (
          <div className={`${s.disclaimer} ${s.hashtag}`}>
            # :- परीक्षा परिणाम बेस्ट फाइव पद्धति के आधार पर तैयार किया गया है .
            परीक्षा परिणाम में # से दर्शाये गए विषय के प्राप्तांक को महायोग में
            सम्मिलित नहीं किया गया है|
          </div>
        ) : (
          ''
        )}
        <div className={s.result_rank}>{getResultData()}</div>
      </div>
    ) : (
      <div className={s.result_show}>
        <div className={s.result_details}>
          {roll_number && (
            <div>
              <div className={s.head}>Roll Number:</div>
              <div className={s.numbers}>{roll_number || ''}</div>
            </div>
          )}
          {roll_code && (
            <div>
              <div className={s.head}>Roll Code:</div>
              <div className={s.numbers}>{roll_code || ''}</div>
            </div>
          )}
          {district && (
            <div>
              <div className={s.head}>District:</div>
              <div className={s.numbers}>{district || ''}</div>
            </div>
          )}
        </div>
        <div className={s.head_one}>Result/Division:</div>
        <div className={s.result_rank}>
          <div className={s.numbers}>{division || ''}</div>
        </div>
      </div>
    );

  const pdfHTML = (
    <div
      id="pdf-image-download"
      style={{
        position: 'absolute',
        left: '-9999px',
      }}
    >
      <div className={s.result_print}>
        <div className={s.toi_logo}>TOI</div>
        <h1 className={s.main_heading}>{pdfTitle || 'Board Results 2024'}</h1>
        {resultHTML}
        {getDiscalimer()}
      </div>
    </div>
  );

  return (
    <>
      {data && data.title && <h1 className={s.main_heading}>{data.title}</h1>}
      {resultHTML}
      {stateName &&
      stateName === 'MP' &&
      classText &&
      classText === '12th' &&
      Array.isArray(subjects) &&
      subjects.length >= 6 ? (
        <div className={s.disclaimer}>
          <span>Note: </span>The 6th subject is additional, not included in the
          grand total.
        </div>
      ) : (
        ''
      )}
      {pdfHTML}
      <div className={s.action_btns}>
        <>
          <div className={s.check_link} onClick={resetForm}>
            Check Another Result
          </div>
          <div className={s.btn_grp}>
            <button
              className={`${s.submit_btn} ${s.download}`}
              onClick={downloadPdf}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
              >
                <path
                  d="M7 10.5769L3.46152 7.03845L4.16923 6.31923L6.5 8.65V0H7.5V8.65L9.83078 6.31923L10.5385 7.03845L7 10.5769ZM1.61537 14C1.15512 14 0.770833 13.8458 0.4625 13.5375C0.154167 13.2292 0 12.8449 0 12.3846V9.96155H1V12.3846C1 12.5385 1.0641 12.6795 1.1923 12.8077C1.32052 12.9359 1.46154 13 1.61537 13H12.3846C12.5385 13 12.6795 12.9359 12.8077 12.8077C12.9359 12.6795 13 12.5385 13 12.3846V9.96155H14V12.3846C14 12.8449 13.8458 13.2292 13.5375 13.5375C13.2292 13.8458 12.8449 14 12.3846 14H1.61537Z"
                  fill="#E21B22"
                />
              </svg>{' '}
              DOWNLOAD
            </button>
            {props.isWapView && (
              <button
                className={`${s.submit_btn} ${s.share}`}
                onClick={shareResult}
              >
                <i />
                SHARE YOUR RESULT
              </button>
            )}
          </div>
        </>
      </div>
      {getDiscalimer()}
    </>
  );
};

export default BoardResultDisplay;
